import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { useCookies } from "react-cookie";
import "../../styles/EventsList.css";
import { FormControlLabel, Switch } from "@mui/material";

const EventsList = () => {
  const navigate = useNavigate();
  const [cookies] = useCookies(["auth_token"]);
  const [events, setEvents] = useState([]);
  const [registeredEvents, setRegisteredEvents] = useState([]);
  const [registeredOnly, setRegisteredOnly] = useState(false);

  // helper to turn "2025-04-10" → "04-10-2025"
  const formatDate = (iso) => {
    if (!iso) return "";
    const [year, month, day] = iso.split("-");
    return `${month}-${day}-${year}`;
  };

  // Fetch events
  useEffect(() => {
    const fetchEvents = async () => {
      try {
        const response = await axios.get("/api/events2");
        const events = response.data.events;

        setEvents(events);
        const filtered = events.filter(
          (event) => event.attendees != null && event.attendees != ""
        );
        setRegisteredEvents(filtered);
      } catch (error) {
        console.error("Error fetching events:", error);
        setError("Failed to fetch events");
      }
    };

    fetchEvents();
  }, [cookies.auth_token]);

  // Handle "Return to Home" button
  const handleReturnToHome = () => {
    navigate("/");
  };

  return (
    <div className="events-container min-h-screen bg-gradient-to-b from-[#7B2D2D] to-[#B56565] flex flex-col items-center py-8">
      {/* Filter to Registered Events Toggle */}
      <div className="w-full max-w-4xl mb-4 flex justify-end gap-4">
        <FormControlLabel
          control={<Switch checked={registeredOnly} />}
          label="Only Registered Events"
          onChange={(event, checked) => {
            setRegisteredOnly(checked);
          }}
          className="flex justify-center items-center bg-white rounded-2xl pr-2"
        />
      </div>
      {/* Event List with Scroll */}
      <ul className="events-list w-full max-w-4xl max-h-[70vh] overflow-y-auto">
        {registeredOnly ?
        registeredEvents.map((event, index) => (
          <li
            key={index}
            className="event-box bg-white rounded-2xl shadow-md p-6 mb-4 flex flex-col md:flex-row md:items-center md:justify-between gap-4">
            <div className="flex-1">
              <p className="text-2xl font-bold text-gray-800">{event.event}</p>
              <p className="text-gray-700">{event.description}</p>
              <p className="text-gray-600">
                <strong>Start Date:</strong> {formatDate(event.startDate)} <br />
                <strong>End Date:</strong> {formatDate(event.endDate)} <br />
                <strong>Registration:</strong> {formatDate(event.beginRegistrationDate)} -{" "}
                {formatDate(event.endRegistrationDate)} <br />
                {(event.attendees != null && event.attendees != "") && (
                  <><strong>Attendees:</strong> {event.attendees}</>
                )}
              </p>
            </div>
            <Link to={`/eventsignup?eventId=${event.eventId}`}>
              <button className="bg-gray-300 text-gray-700 rounded-full px-6 py-2 shadow-lg hover:bg-gray-400 whitespace-nowrap">
                {(event.attendees == null || event.attendees == "") ? "Register for Event" : "Modify Registration"}
              </button>
            </Link>
          </li>
        )) :
        events.map((event, index) => (
          <li
            key={index}
            className="event-box bg-white rounded-2xl shadow-md p-6 mb-4 flex flex-col md:flex-row md:items-center md:justify-between gap-4">
            <div className="flex-1">
              <p className="text-2xl font-bold text-gray-800">{event.event}</p>
              <p className="text-gray-700">{event.description}</p>
              <p className="text-gray-600">
                <strong>Start Date:</strong> {formatDate(event.startDate)} <br />
                <strong>End Date:</strong> {formatDate(event.endDate)} <br />
                <strong>Registration:</strong> {formatDate(event.beginRegistrationDate)} -{" "}
                {formatDate(event.endRegistrationDate)} <br />
                {(event.attendees != null && event.attendees != "") && (
                  <><strong>Attendees:</strong> {event.attendees}</>
                )}
              </p>
            </div>
            <Link to={`/eventsignup?eventId=${event.eventId}`}>
              <button className="bg-gray-300 text-gray-700 rounded-full px-6 py-2 shadow-lg hover:bg-gray-400 whitespace-nowrap">
                {(event.attendees == null || event.attendees == "") ? "Register for Event" : "Modify Registration"}
              </button>
            </Link>
          </li>
        ))}
      </ul>

      {/* Return to Home Button */}
      <div className="flex justify-center mt-4 mb-6">
        <button
          onClick={handleReturnToHome}
          className="bg-gray-300 text-black rounded-full px-6 py-3 shadow-lg hover:bg-gray-400 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500">
          Return to Home
        </button>
      </div>
    </div>
  );
};

export default EventsList;
